import { Injectable } from '@angular/core';
import { AuthService } from '@app/core/services';
import { environment } from '@app/env';
import { Socket } from 'ngx-socket-io';

@Injectable({ providedIn: 'root' })
export class SocketService extends Socket {
	constructor(private auth: AuthService) {
		super({
			url: environment.SOCKET_IO_URL,
			options: {
				path: '/ws-conversation',
				reconnectionAttempts: 5,
				reconnectionDelay: 1000,
				reconnectionDelayMax: 5000,
				transports: ['websocket'],
				withCredentials: true,
				/**
				 * El JWT va en `auth`, NO en `query`.
				 *
				 * Como query param acababa en la URL del WebSocket
				 * (`ws://…/ws-conversation/?authorization=Bearer eyJ…`), y por tanto
				 * en texto plano en la consola del navegador — confirmado en una
				 * prueba end-to-end — además de en los logs de proxies,
				 * balanceadores e historiales, que registran la URL aunque no
				 * registren el cuerpo del handshake. `auth` viaja en el payload del
				 * handshake de Socket.io y no aparece en ninguno de esos sitios.
				 *
				 * El middleware del backend acepta ambos durante la transición.
				 */
				auth: {
					authorization: `Bearer ${auth.JWT}`,
				},
			},
		});
	}
}
